(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('CustomUser', CustomUser);

    CustomUser.$inject = ['$resource', 'DateUtils'];

    function CustomUser ($resource, DateUtils) {
        var resourceUrl =  'api/custom-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                        data.processingOfPersonalDataContractAgreement = DateUtils.convertDateTimeFromServer(data.processingOfPersonalDataContractAgreement);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
